//배경 div - 컴포넌트의 선택 및 이동을 처리 (Moveable & Selecto 통합)
//편집 전용으로 사용됨
import DRComponent from "./DRComponent2";
import Moveable from "moveable";
import Selecto from "selecto";
import { getElementInfo } from 'moveable';

class DRBackground extends HTMLElement {

    static copycomponent = [];
    model;
    undolist;
    redolist;
    FIRST_POS;
    component_list = [];
    cm_targets;       //selecto 라이브러리를 통해 선택된 컴포넌트들

    constructor(model, select_item, parent, face){

        super();
        this.classList.add("screen");

        //배경 div
        this.tabIndex = 0;                         //이걸 해줘야 키다운 이벤트가 먹는다.
        this.model = model;
        this.FIRST_POS     = {x:0, y:0};

        this.style.height  = "100%";
        this.style.width   = "100%";
        this.style.display = "block";  // 이 줄 추가

        //undo redo 리스트
        this.undolist = [];
        this.redolist = [];

        this.parent = parent;
        this.face   = face;

        // 키보드 이동 상태 플래그
        this.keyboardMoving = false;

        //선택된 아이템의 info창 갱신을 위한 연결 객체
        this.select_item = select_item;

        //배경 처리
        if(model.BGTYPE == 0){
            //컬러 배경
            this.style.backgroundColor = "#"+model.BGCOLOR;
            this.style.backgroundImage = "";
            this.style.backgroundRepeat = "no-repeat";
        }else{
            //이미지 배경
            //this.style.backgroundSize = `${this.getPrintWidth(this.model.LAYOUT_WIDTH)}mm  ${this.getPrintHeight(this.model.LAYOUT_HEIGHT)}mm`;
            this.style.backgroundSize = "100% 100%";
            //this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundImage = "url('"+this.model.IMG+"')"
            this.style.backgroundRepeat = "no-repeat";
        }

        this.component_list = [];

        //Moveable과 Selecto 초기화
        this.initializeMoveable();
        this.initializeSelecto();
        
        this.addEventListener('keydown', this.onkeydown);
        this.addEventListener('keyup', this.onkeyup);
        //this.onkeydown    = this.onkeydown.bind(this);

        //함수 - Moveable과 Selecto로 대체됨

    }

    destroy(){
        this.removeEventListener('keydown', this.onkeydown);
        this.removeEventListener('keyup', this.onkeyup);
    }

    //Moveable 초기화
    initializeMoveable() {
        this.moveable = new Moveable(this, {
            
            draggable: true,
            rotatable: true,
            resizable: true,
            scalable: true,

            origin: false,      //중심부 렌더링
            keepRatio: false,   //리사이즈시 비율 유지 유무

            //verticalGuidelines: [0,this.contentStore.content_model.height/2,this.contentStore.content_model.height],
            //horizontalGuidelines: [0,this.contentStore.content_model.width/2,this.contentStore.content_model.width],
            snapThreshold: 5,

            snappable: true,
            isDisplaySnapDigit: true,
            isDisplayInnerSnapDigit: false,

            snapGap: true,
            snapDirections: {"top":true,"left":true,"bottom":true,"right":true,"center":true,"middle":true},
            elementSnapDirections: {"top":true,"left":true,"bottom":true,"right":true,"center":true,"middle":true},
            snapDigit: 0,      
            maxSnapElementGuidelineDistance: null,
    
        }).on("dragStart", e=>{

            console.log(`dragStart`);

            e.set([e.target.model.TEMP_POSX, e.target.model.TEMP_POSY]);
            
            // 드래그 시작시 현재 상태를 언두에 저장 (이동 전 상태)
            if(this.component_list.includes(e.target) && this.selecto.getSelectedTargets().length <= 1){
                this.saveUndo("move");
            }
    
          }).on("drag", e => {

            console.log(`drag`);

            // 해당 컴포넌트가 현재 DRBackground의 자식인지 확인
            if(!this.component_list.includes(e.target)) {
                return; // 다른 면의 컴포넌트면 처리하지 않음
            }

            e.target.model.TEMP_POSX     = Math.floor(e.beforeTranslate[0]);
            e.target.model.TEMP_POSY     = Math.floor(e.beforeTranslate[1]);
            e.target.model.LAYOUT_POSX   = Math.floor(e.beforeTranslate[0]);
            e.target.model.LAYOUT_POSY   = Math.floor(e.beforeTranslate[1]);
            e.target.updateTransElement();
            
          }).on("dragEnd", () => {
            //드래그 종료 - 언두는 dragStart에서 이미 저장했으므로 여기서는 처리 안함
            console.log(`dragEnd`);

          }).on("rotateStart", e => {
            e.set(e.target.model.ROTATE);
            
            // 단일 컴포넌트 회전 시작시 언두 저장
            if(this.component_list.includes(e.target)) {
                this.saveUndo("rotate");
            }
    
          }).on("rotate", e => {
            e.target.model.ROTATE = Math.floor(e.beforeRotate);
            e.target.updateTransElement();
    
          }).on("resizeStart", e => {
            e.setOrigin(["%", "%"]);
            if (e.dragStart) {
              e.dragStart.set([e.target.model.TEMP_POSX, e.target.model.TEMP_POSY]);
            }
            
            // 단일 컴포넌트 리사이즈 시작시 언두 저장
            if(this.component_list.includes(e.target)) {
                this.saveUndo("resize");
            }
          }).on("resize", e => {
            
            e.target.model.LAYOUT_WIDTH  = Math.floor(e.width);
            e.target.model.LAYOUT_HEIGHT = Math.floor(e.height);
            e.target.model.TEMP_POSX = Math.floor(e.drag.beforeTranslate[0]);
            e.target.model.TEMP_POSY = Math.floor(e.drag.beforeTranslate[1]);
    
            //width와 height값이 중요하다. 이 정보가 있어야 나중에 복원이 가능함 매트릭스는 공간에 대한 변형 정보라 넓이, 높이 정보가 없음. 그래서 넓이, 높이 + 매트릭스 둘 다 가지고 있어야 함.
            e.target.updateTransElementAll();
    
    
          // eslint-disable-next-line no-unused-vars
          }).on("scale", e => {
            //스케일을 쓸필요가 있나? ratio를 쓰면 될거 같은데?
            
    
          }).on("dragGroupStart", e => {

            e.events.forEach(({ target, set }) => {
                set([target.model.LAYOUT_POSX, target.model.LAYOUT_POSY]);
            });
            
            // 다중 선택 드래그 시작시 현재 상태를 언두에 저장 (이동 전 상태)
            const isOurComponents = e.events.every(({ target }) => this.component_list.includes(target));
            if(isOurComponents && e.events.length > 0) {
                this.saveUndo("move");
            }
          
          }).on("dragGroup", e => {
            
            e.events.forEach(({ target, beforeTranslate }) => {
                
                // 해당 컴포넌트가 현재 DRBackground의 자식인지 확인
                if(!this.component_list.includes(target)) {
                    return; // 다른 면의 컴포넌트면 처리하지 않음
                }
                
                target.model.TEMP_POSX      = Math.floor(beforeTranslate[0]);
                target.model.TEMP_POSY      = Math.floor(beforeTranslate[1]);
                target.model.LAYOUT_POSX   = Math.floor(beforeTranslate[0]);
                target.model.LAYOUT_POSY   = Math.floor(beforeTranslate[1]);
                target.updateTransElement();
                
            });
    
          }).on("dragGroupEnd", () => {        
            // 다중 드래그 종료 - 언두는 dragGroupStart에서 이미 저장했으므로 여기서는 처리 안함
    
          }).on("rotateGroupStart", e => {

            // 회전 시작시 현재 상태를 언두에 저장 (회전 전 상태)
            const isOurComponents = e.events.every(({ target }) => this.component_list.includes(target));
            
            if(isOurComponents && e.events.length > 0) {
                this.saveUndo("rotate");
            }

            e.events.forEach(({target, set, dragStart}) => {
                set(target.model.ROTATE);
                dragStart.set([target.model.LAYOUT_POSX, target.model.LAYOUT_POSY]);
            });            
    
          }).on("rotateGroup", e => {
            e.events.forEach(({ target, beforeRotate, drag }) => {
                const beforeTranslate = drag.beforeTranslate;
                target.model.ROTATE = Math.floor(beforeRotate);
                target.model.TEMP_POSX = Math.floor(beforeTranslate[0]);
                target.model.TEMP_POSY = Math.floor(beforeTranslate[1]);
                target.model.LAYOUT_POSX = Math.floor(beforeTranslate[0]);
                target.model.LAYOUT_POSY = Math.floor(beforeTranslate[1]);
                target.updateTransElement();
            });
    
          }).on("resizeGroupStart", e => {
            
            // 다중 컴포넌트 리사이즈 시작시 언두 저장  
            const isOurComponents = e.events.every(({ target }) => this.component_list.includes(target));
            
            if(isOurComponents && e.events.length > 0) {
                this.saveUndo("resize");
            }
            
            e.events.forEach((ev) => {
                ev.setOrigin(["%", "%"]);
                if(ev.dragStart){
                  ev.dragStart.set([ev.target.model.TEMP_POSX, ev.target.model.TEMP_POSY]);
                }
            });
    
          }).on("resizeGroup", e => {
            e.events.forEach((ev) => {
                ev.target.model.LAYOUT_WIDTH   = Math.floor(ev.width);
                ev.target.model.LAYOUT_HEIGHT  = Math.floor(ev.height);
                ev.target.model.TEMP_POSX  = Math.floor(ev.drag.beforeTranslate[0]);
                ev.target.model.TEMP_POSY  = Math.floor(ev.drag.beforeTranslate[1]);
                ev.target.model.LAYOUT_POSX = Math.floor(ev.drag.beforeTranslate[0]);
                ev.target.model.LAYOUT_POSY = Math.floor(ev.drag.beforeTranslate[1]);
                ev.target.updateTransElementAll();
            });
    
          }).on("clickGroup", e => {
            this.selecto.clickTarget(e.inputEvent, e.inputTarget);
          });
    
    }

    //Selecto 초기화
    initializeSelecto() {
        this.selecto = new Selecto({
            container: this,  // 각 DRBackground를 컨테이너로 설정
            selectableTargets: [".drag"],     //선택할 수 있는 타겟
            hitRate: 0,
            selectByClick: true,
            selectFromInside: false,
            toggleContinueSelect: "shift",
            ratio: 0,
            getElementRect: getElementInfo
        });

        // Selecto 이벤트 처리
        this.selecto.on("dragStart", e => {
            console.log(`selecto dragStart`);
            if(this.moveable == null || this.cm_targets == null){
                e.inputEvent.preventDefault();
                return;
            }
            const target = e.inputEvent.target;
            if(this.moveable.isMoveableElement(target) || this.cm_targets.some(t => t === target || t.contains(target))
            ){
                e.stop();
            }

        // eslint-disable-next-line no-unused-vars
        }).on("select", e => {
            console.log(`selecto select`);
            var selectlist = new Set();
            var elements   = this.selecto.getSelectedTargets();
            

            elements.forEach(target=>{
                //선택한 컴포넌트가 그룹객체면 그룹 전체 선택
                if(target.model && target.model.isgroup){
                  var gtarget = [].slice.call(document.querySelectorAll("."+target.model.groupid));
                  gtarget.forEach(gt=>{
                    selectlist.add(gt);
                  });
                }else{
                  selectlist.add(target);
                }
            });        
            const sl = Array.from(selectlist);
            if(sl.length == 1){
              //단일건을 이렇게 안넣으면 버그가 발생함. 한템포 뒤에 모델이 셋팅됨.
              this.cm_targets      = elements;
              this.moveable.target = elements;
              
              this.parent.selectitem(elements[0].model);
              this.parent.colorupdate(); // 컬러 정보 업데이트
              
              // 키보드 이벤트를 받기 위해 포커스 유지
              this.focus({preventScroll: true});
  
            }else if(sl.length > 1){
              
              this.moveable.target    = sl;
              this.cm_targets         = sl;

              //this.parent.selectitem(elements[0].model); //컬러값 업데이트
              //this.contentStore.select_component     = null;
              //this.contentStore.select_componentlist = sl;
              //this.$emit('selectComponent', sl);
              
              // 현재 면을 활성 면으로 설정
              this.parent.selectface(this.face);
              
              // 키보드 이벤트를 받기 위해 포커스 유지
              this.focus({preventScroll: true});
  
            }else{
              
              //아무것도 없는 상태 - 스크린 배경을 선택시켜라.
              //this.cm_targets = [];
              //this.cm_moveable.target = null;
              //this.$emit('selectComponent', elements);
  
            }

        }).on("selectEnd", e => {
            console.log(`selecto selectEnd`);
            if(e.isDragStartEnd) {
                console.log(`selecto selectEnd1`);
                e.inputEvent.preventDefault();
                
                // waitToChangeTarget 호출 전에 타겟 먼저 설정
                this.cm_targets = e.selected;
                this.moveable.target = this.cm_targets;
                
                this.moveable.waitToChangeTarget().then(() => {
                    console.log(`selecto selectEnd2 - waitToChangeTarget 완료`);
                    this.moveable.dragStart(e.inputEvent);
                });
            }else{
              this.cm_targets = e.selected;
              this.moveable.target = this.cm_targets;
              
              if(this.cm_targets.length == 0){
                //아무것도 선택이 안된 상황 배경 스크린 선택 처리
                this.parent.selectface(this.face);
                this.parent.selectitem(this.model); //배경을 selectitem으로 설정

                //this.contentStore.select_component = null;
                //this.contentStore.select_componentlist = null;
                
                // 키보드 이벤트를 받기 위해 포커스 유지
                this.focus({preventScroll: true});
  
              }else if(this.cm_targets.length == 1){
                // 단일 선택은 이미 select 이벤트에서 처리했으므로 여기서는 면 선택만
                this.parent.selectface(this.face);
                
                // 키보드 이벤트를 받기 위해 포커스 유지
                this.focus({preventScroll: true});
  
              }else if(this.cm_targets.length > 1){
                //드래그로 여러개의 컴포넌트가 선택된 상황
                this.parent.selectitem(this.selecto.getSelectedTargets()[0].model);
                
                // 현재 면을 활성 면으로 설정
                this.parent.selectface(this.face);
                
                // 키보드 이벤트를 받기 위해 포커스 유지
                this.focus({preventScroll: true});
                
                //스크린을 널로 만들면 화면단위 재생안됨.
                //this.contentStore.select_screen = null;
              }
  
              //레이어 싱크
              //this.$emitter.emit("synclayer");

            }

        });
    }

    //선택된 요소들로 Moveable 업데이트
    updateMoveableTargets() {
        if(this.moveable && this.cm_targets && this.cm_targets.length > 0) {
            this.moveable.updateRect();
        }
    }

    //엘리먼트로 컴포넌트 찾기
    getComponentByElement(element) {
        return this.component_list.find(cm => cm === element);
    }

    //transform에서 모델 업데이트
    updateModelFromTransform(element, transform) {
        const component = this.getComponentByElement(element);
        if (!component) return;

        // transform matrix에서 좌표와 회전값 추출
        const matrix = new DOMMatrix(transform);
        component.model.LAYOUT_POSX = matrix.e;
        component.model.LAYOUT_POSY = matrix.f;
        component.model.TEMP_POSX = matrix.e;
        component.model.TEMP_POSY = matrix.f;
        
        // 회전값 추출 (라디안에서 도로 변환)
        const rotation = Math.atan2(matrix.b, matrix.a) * (180 / Math.PI);
        component.model.ROTATE = Math.round(rotation);
    }

    //선택 해제
    clearSelection() {
        this.selecto.setSelectedTargets([]);
        this.moveable.target = [];
        this.cm_targets = [];
        
        // 현재 활성 면인 경우에만 인포창을 배경으로 설정
        if(this.parent.CURRENT_FACE === this.face) {
            this.parent.selectitem(this.model);
            this.parent.colorupdate(); //컬러값 업데이트
        }
    }

    //인포 패널 업데이트
    updateInfoPanel() {
        const selectedComponents = this.selecto.getSelectedTargets();
        
        if (selectedComponents.length === 1) {
            // 단일 선택
            this.parent.selectitem(selectedComponents[0].model);
        } else if (selectedComponents.length > 1) {
            // 다중 선택 - 첫번째 컴포넌트 정보 표시
            this.parent.selectitem(selectedComponents[0].model);
        } else {
            // 선택 없음
            this.parent.selectitem(this.model);
        }
        
        this.parent.colorupdate();
    }

    setLayoutChange(dw, dh){

        this.model.LAYOUT_WIDTH  = dw;
        this.model.LAYOUT_HEIGHT = dh;

        //배경 처리
        if(this.model.BGTYPE == 0){
            //컬러 배경
            this.style.backgroundColor = "#"+this.model.BGCOLOR;
            this.style.backgroundImage = "";
            this.style.backgroundRepeat = "no-repeat";
        }else{
            //이미지 배경
            this.style.backgroundColor = "#ffffff";
            this.style.backgroundSize = "100% 100%";
            //this.style.backgroundSize = `${this.getPrintWidth(this.model.LAYOUT_WIDTH)}mm  ${this.getPrintHeight(this.model.LAYOUT_HEIGHT)}mm`;
            //this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundImage = "url('"+this.model.IMG+"')"
            this.style.backgroundRepeat = "no-repeat";
        }

        //컴포넌트 div
        this.style.height    = this.model.LAYOUT_HEIGHT + "px";
        this.style.width     = this.model.LAYOUT_WIDTH + "px";

    }

    //DR컴포넌트 객체 추가
    addComponent(cm, useUndo){

        this.component_list.push(cm);
        this.appendChild(cm);


        //언두 추가
        if(useUndo){
            var undo_list = [];
            var clone_model = Object.assign({}, cm.model); //데이터 카피
            var clone_obj = Object.assign({atype:"add", model:clone_model}); //데이터 카피
            clone_obj.component = cm;
            undo_list.push(clone_obj);
            if(undo_list.length > 0){
                if(this.undolist.length > 100){
                    this.undolist.splice(0, 1);
                }
                this.undolist.push(undo_list);
                this.redolist.splice(0, this.redolist.length);
            }
        }
    }

    //꽉채우기
    fullsize(){
        const selectedComponents = this.selecto.getSelectedTargets();
        if(selectedComponents.length > 0){

            var undo_list = [];
            selectedComponents.forEach(el=>{
                    //undo리스트를 저장
                    var clone_model = Object.assign({}, el.model); //데이터 카피
                    var clone_obj   = Object.assign({atype:"full", model:clone_model}); //데이터 카피
                    clone_obj.component = el;
                    undo_list.push(clone_obj);
                    el.setWidth(this.model.LAYOUT_WIDTH);
            });

            //언두 리스트가 발생했다면 저장
            if(undo_list.length > 0){
                if(this.undolist.length > 100){
                    this.undolist.splice(0, 1);
                }
                this.undolist.push(undo_list);
                this.redolist.splice(0, this.redolist.length);
            }

            this.updateMoveableTargets();
            this.focus({preventScroll: true});
        }   
    }

    //중앙정렬
    centeralign(){
        const selectedComponents = this.selecto.getSelectedTargets();
        if(selectedComponents.length > 0){
            var undo_list = [];
            selectedComponents.forEach(el=>{
                    //undo리스트를 저장
                    var clone_model = Object.assign({}, el.model); //데이터 카피
                    var clone_obj = Object.assign({atype:"center", model:clone_model}); //데이터 카피
                    clone_obj.component = el;
                    undo_list.push(clone_obj);

                    el.centerPos(this.model.LAYOUT_WIDTH);
            });
            //언두 리스트가 발생했다면 저장
            if(undo_list.length > 0){
                if(this.undolist.length > 100){
                    this.undolist.splice(0, 1);
                }
                this.undolist.push(undo_list);
                this.redolist.splice(0, this.redolist.length);
            }

            this.updateMoveableTargets();
            this.focus({preventScroll: true});
        }   
    }

    //컴포넌트 맨앞으로 가져오기
    getfront(){
        var slist = [];
        var undo_list = [];
        const selectedComponents = this.selecto.getSelectedTargets();
        
        if(selectedComponents.length === 0) return;
        
        // 선택된 컴포넌트들만 먼저 수집
        selectedComponents.forEach(cm => {
            if(this.component_list.includes(cm)) {
                var idx = this.component_list.indexOf(cm);
                //undo 저장
                var clone_model = Object.assign({}, cm.model);
                var clone_obj   = Object.assign({atype:"orderfront", model:clone_model});
                clone_obj.component = cm;
                clone_obj.zidx      = idx;
                undo_list.push(clone_obj);
                slist.push(cm);
            }
        });
        
        // 선택된 컴포넌트들을 배열에서 제거
        slist.forEach(cm => {
            var idx = this.component_list.indexOf(cm);
            if(idx > -1) {
                this.component_list.splice(idx, 1);
                this.removeChild(cm);
            }
        });
        
        // 맨 뒤에 다시 추가 (DOM 순서도 함께)
        slist.forEach(cm => {
            this.component_list.push(cm);
            this.appendChild(cm);
        });

        //언두 리스트가 발생했다면 저장
        if(undo_list.length > 0){
            if(this.undolist.length > 100){
                this.undolist.splice(0, 1);
            }
            this.undolist.push(undo_list);
            this.redolist.splice(0, this.redolist.length);
        }
        
        //셀렉트값 복구 - Selecto로 선택 상태 복구
        if(slist.length > 0) {
            this.selecto.setSelectedTargets(slist);
        }

        //this.redrawComponent();
    }

    //컴포넌트 맨뒤로 밀기
    pushback(){
        
        var slist = [];
        var undo_list = [];
        const selectedComponents = this.selecto.getSelectedTargets();
        
        if(selectedComponents.length === 0) return;
        
        // 선택된 컴포넌트들만 먼저 수집
        selectedComponents.forEach(cm => {
            if(this.component_list.includes(cm)) {
                var idx = this.component_list.indexOf(cm);
                //undo 저장
                var clone_model = Object.assign({}, cm.model);
                var clone_obj   = Object.assign({atype:"orderback", model:clone_model});
                clone_obj.component = cm;
                clone_obj.zidx      = idx;
                undo_list.push(clone_obj);
                slist.push(cm);
            }
        });
        
        // 선택된 컴포넌트들을 배열에서 제거
        slist.forEach(cm => {
            var idx = this.component_list.indexOf(cm);
            if(idx > -1) {
                this.component_list.splice(idx, 1);
                this.removeChild(cm);
            }
        });
        
        // 맨 앞에 다시 추가 (DOM 순서도 함께)
        slist.reverse().forEach(cm => { // reverse로 순서 유지
            this.component_list.unshift(cm);
            this.insertBefore(cm, this.firstChild);
        });

        //언두 리스트가 발생했다면 저장
        if(undo_list.length > 0){
            if(this.undolist.length > 100){
                this.undolist.splice(0, 1);
            }
            this.undolist.push(undo_list);
            this.redolist.splice(0, this.redolist.length);
        }

        //셀렉트값 복구 - Selecto로 선택 상태 복구
        if(slist.length > 0) {
            this.selecto.setSelectedTargets(slist);
        }
        //parentElement.insertBefore(newElement, parentElement.children[2]);
        //this.redrawComponent();
    }

    //선택된 컴포넌트 삭제
    removeComponent(){
        var undo_list = [];
        const selectedComponents = this.selecto.getSelectedTargets();
        
        for(var i = this.component_list.length-1 ; i >=0 ; i--){
            const cm = this.component_list[i];
            if(selectedComponents.includes(cm)){
                
                //undo 저장
                var clone_model = Object.assign({}, cm.model); //데이터 카피
                var clone_obj = Object.assign({atype:"delete", model:clone_model}); //데이터 카피
                clone_obj.component = cm;
                
                undo_list.push(clone_obj);

                var idx = this.component_list.indexOf(cm);
                if(idx > -1){
                    this.component_list.splice(idx, 1);
                    this.removeChild(cm);
                }
            }
        }
        //언두 리스트가 발생했다면 저장
        if(undo_list.length > 0){
            if(this.undolist.length > 100){
                this.undolist.splice(0, 1);
            }
            this.undolist.push(undo_list);
            this.redolist.splice(0, this.redolist.length);
        }

        this.clearSelection();
    }

    //초기화
    clearBackground(){

        //undo redo 초기화
        this.undolist.splice(0, this.undolist.length);
        this.redolist.splice(0, this.redolist.length);

        for(var i = this.component_list.length-1 ; i >=0 ; i--){
            const cm = this.component_list[i];
            var idx = this.component_list.indexOf(cm);
            
            if(idx > -1){
                this.component_list.splice(idx, 1);
                this.removeChild(cm);
            }
        }
        this.clearSelection();

        //이걸 건들면 문제됨.. 참조변수가 변조됨..
        //this.model.ISBG           = 1;
        //this.model.COMPONENT_TYPE = 0;
        this.model.BGTYPE  = 0;
        this.model.BGCOLOR = "808080";
        this.model.IMG = null;
        this.model.LOCALIMG = null;

        //컬러 배경
        this.style.backgroundColor = "#808080";
        this.style.backgroundImage = "";
        this.style.backgroundRepeat = "no-repeat";
        
        
        //갱신
        /*
        if(this.model.BGTYPE == 0){
            //컬러 배경
            this.style.backgroundColor = "#"+this.model.BGCOLOR;
            this.style.backgroundImage = "";
            this.style.backgroundRepeat = "no-repeat";
        }else{
            //이미지 배경
            this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundImage = "url('"+this.model.IMG+"')"
            this.style.backgroundRepeat = "no-repeat";
        }
        */
    }

    //배경 업데이트
    updateBackground(newmodel){
        
        this.model = newmodel;

        //배경 처리
        if(this.model.BGTYPE == 0){
            //컬러 배경
            this.style.backgroundColor = "#"+this.model.BGCOLOR;
            this.style.backgroundImage = "";
            this.style.backgroundRepeat = "no-repeat";
        }else{
            //이미지 배경
            this.style.backgroundColor  = "#ffffff";
            this.style.backgroundSize   = "100% 100%";
            //this.style.backgroundSize = `${this.getPrintWidth(this.model.LAYOUT_WIDTH)}mm  ${this.getPrintHeight(this.model.LAYOUT_HEIGHT)}mm`;
            //this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
            this.style.backgroundImage = `url("${this.model.IMG}")`;
            this.style.backgroundRepeat = "no-repeat";
        }
    }
    
    //모든 선택 취소하기(출력전에 에디트 라인 안보이게 해야함)
    selectCancel(){
        this.clearSelection();
    }

    //현대 누적된 언두카운트
    getUndoSize(){
        return this.undolist.length;
    }

    //현재 선택된 컴포넌트의 상태를 언두에 저장한다.undolist
    saveUndo(typename){
        // 현재 활성화된 면인지 확인 (display가 none이면 비활성 상태)
        if(this.style.display === "none" || this.offsetParent === null) {
            return;
        }
        
        // 부모의 CURRENT_FACE가 있으면 그것으로도 확인
        if(this.parent && this.parent.CURRENT_FACE !== undefined && this.parent.CURRENT_FACE !== this.face) {
            return;
        }
        
        var undo_list = [];
        const selectedComponents = this.selecto.getSelectedTargets();
        
        selectedComponents.forEach(cm=>{
                //undo리스트를 저장
                var clone_model = Object.assign({}, cm.model); //데이터 카피
                var clone_obj   = Object.assign({atype:typename, model:clone_model}); //데이터 카피
                clone_obj.component = cm;
                undo_list.push(clone_obj);
        });
        //언두 리스트가 발생했다면 저장
        if(undo_list.length > 0){
            if(this.undolist.length > 100){
                this.undolist.splice(0, 1);
            }
            this.undolist.push(undo_list);
            this.redolist.splice(0, this.redolist.length);
        }
    }

    //배경 상태를 언두에 저장한다.
    saveBGUndo(typename){
        var undo_list = [];
        var clone_model = Object.assign({}, this.model);           
        var clone_obj   = Object.assign({atype:typename, model:clone_model});
        undo_list.push(clone_obj);
        if(undo_list.length > 0){
            if(this.undolist.length > 100){
                this.undolist.splice(0, 1);
            }
            this.undolist.push(undo_list);
            this.redolist.splice(0, this.redolist.length);
        }
    }


    //선택된 객체의 model값 변경에 따른 갱신
    updateComponent(){
        const selectedComponents = this.selecto.getSelectedTargets();
        selectedComponents.forEach(cm=>{
            cm.updateTransElement();
        });
        
        // Moveable 타겟 업데이트 및 위치 갱신
        if(this.moveable && selectedComponents.length > 0) {
            this.moveable.updateRect();
        }
    }


    //포인트 span 생성해서 리턴 (Moveable로 대체됨)
    createPointElement(){
        // 이 메소드는 Moveable이 대체하므로 더 이상 사용되지 않음
        return null;
    }
    

    onkeydown = (ev) => {

        if(ev.ctrlKey){

            if(ev.keyCode == 90){    //Ctrl+Z undo
                
                // 이벤트 전파 방지 및 기본 동작 차단
                ev.preventDefault();
                ev.stopPropagation();
                
                // 현재 활성화된 면인지 확인
                if(this.parent && this.parent.CURRENT_FACE !== undefined && this.parent.CURRENT_FACE !== this.face) {
                    return;
                }
                

                //에디트 영역은 취소시킨다.
                this.clearSelection();
                this.style.cursor = "default";
                this.mode = "";
                this.parent.selectface(this.face);    //parent에 선택된 배경의 방향을 콜백

                //배경을 인포창에 연결 
                this.parent.selectitem(this.model);
                this.parent.colorupdate(); //컬러값 업데이트                

                if(this.undolist.length > 0){

                    var ulist = this.undolist.pop();
                    const redo_list = [];

                    if(ulist[0].atype == "orderfront" || ulist[0].atype == "orderback"){
                        //순서변경은 역순으로 처리해야 해서 분리함.
                        for(var i = ulist.length-1 ; i >=0 ; i--){
                            //현재 상태를 언두로 남긴다.
                            const undo = ulist[i];
                            const clone_model = Object.assign({}, undo.component.model);
                            const clone_obj   = Object.assign({atype:undo.atype, model:clone_model});

                            //맨앞으로 순서를 변경할 것을 원래 위치로 돌린다.
                            const idx = this.component_list.indexOf(undo.component);
                            if(idx > -1){
                                this.component_list.splice(idx, 1);                        //리스트에서 제거
                                this.component_list.splice(undo.zidx, 0, undo.component);  //원래 위치에 추가
                                this.removeChild(undo.component);
                                this.insertBefore(undo.component, this.children[undo.zidx]);
                            } 

                            //현재 데이터를 리두에 넣기
                            clone_obj.component = undo.component;
                            redo_list.push(clone_obj);
    
                            //언두 처리
                            undo.component.model = undo.model;
                            undo.component.model = undo.model;
                            undo.component.updateTransElement();
                        }

                    }else if(ulist[0].atype == "bginfo"){
                        //명찰의 가장 밑 배경
                        ulist.forEach(undo=>{
                            //현재 상태를 리두로 남긴다.
                            const clone_model = Object.assign({}, this.model);
                            const clone_obj   = Object.assign({atype:undo.atype, model:clone_model});
                            redo_list.push(clone_obj);
                                
                            //언두 처리 (배경 다시 그리기)
                            this.model = undo.model;
                            if(this.model.BGTYPE == 0){
                                //컬러 배경
                                this.style.backgroundColor = "#"+this.model.BGCOLOR;
                                this.style.backgroundImage = "";
                                this.style.backgroundRepeat = "no-repeat";
                            }else{
                                //이미지 배경
                                this.style.backgroundSize = "100% 100%";
                                //this.style.backgroundSize = `${this.getPrintWidth(this.model.LAYOUT_WIDTH)}mm  ${this.getPrintHeight(this.model.LAYOUT_HEIGHT)}mm`;
                                //this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
                                this.style.backgroundImage = "url('"+this.model.IMG+"')"
                                this.style.backgroundRepeat = "no-repeat";
                            }
                        });

                    }else{

                        ulist.forEach(undo=>{
                        
                            //현재 상태를 언두로 남긴다.
                            const clone_model = Object.assign({}, undo.component.model);
                            const clone_obj   = Object.assign({atype:undo.atype, model:clone_model});
    
                            //undo는 atype의 반대로 처리 redo는 제대로 다시 처리
                            if(undo.atype == "add"){
                                //추가된 내용을 다시 지운다.
                                const idx = this.component_list.indexOf(undo.component);
                                if(idx > -1){
                                    this.component_list.splice(idx, 1);
                                    this.removeChild(undo.component);
                                }
    
                            }else if(undo.atype == "delete"){
                                //삭제된 내용을 다시 추가한다.
                                this.component_list.push(undo.component);
                                this.appendChild(undo.component);
                            }    

                            //현재 데이터를 리두에 넣기
                            clone_obj.component = undo.component;
                            redo_list.push(clone_obj);
    
                            //언두 처리 - 모델 데이터 복원
                            
                            undo.component.model = undo.model;
                            
                            // TEMP 값들도 LAYOUT 값과 동기화
                            undo.component.model.TEMP_POSX = undo.component.model.LAYOUT_POSX;
                            undo.component.model.TEMP_POSY = undo.component.model.LAYOUT_POSY;
                            undo.component.model.TEMP_WIDTH = undo.component.model.LAYOUT_WIDTH;
                            undo.component.model.TEMP_HEIGHT = undo.component.model.LAYOUT_HEIGHT;
                            
                            undo.component.updateTransElement();
                            
                            // 강제 DOM 갱신 - 여러 방법 시도
                            const targetTransform = `translateX(${undo.component.model.LAYOUT_POSX}px) translateY(${undo.component.model.LAYOUT_POSY}px) rotate(${undo.component.model.ROTATE}deg)`;
                            
                            // 스타일을 강제로 덮어쓰기 (!important 처럼)
                            undo.component.style.setProperty('transform', targetTransform, 'important');
                            undo.component.style.setProperty('width', undo.component.model.LAYOUT_WIDTH + 'px', 'important');
                            undo.component.style.setProperty('height', undo.component.model.LAYOUT_HEIGHT + 'px', 'important');
                            
                            // 강제 리플로우 트리거
                            undo.component.offsetHeight; // 브라우저가 스타일을 다시 계산하도록 강제
                            
                            
    
                        });                        
                        
                    }

                    this.redolist.push(redo_list);
                    
                    // 언두 후 관련 컴포넌트들을 선택 상태로 복원
                    const componentsToSelect = [];
                    ulist.forEach(undo => {
                        if(undo.component && this.component_list.includes(undo.component)) {
                            componentsToSelect.push(undo.component);
                        }
                    });
                    
                    if(componentsToSelect.length > 0) {
                        // 먼저 Moveable 타겟을 제거해서 간섭 방지
                        this.moveable.target = null;
                        
                        // DOM 위치가 확실히 적용되도록 더 긴 지연
                        setTimeout(() => {
                            this.selecto.setSelectedTargets(componentsToSelect);
                            this.moveable.target = componentsToSelect;
                            this.cm_targets = componentsToSelect;
                            
                            // Moveable 영역 업데이트
                            this.moveable.updateRect();
                        }, 50);
                        
                        if(componentsToSelect.length === 1) {
                            this.parent.selectitem(componentsToSelect[0].model);
                            // Vue 반응성을 위해 SELECT_ITEM을 직접 업데이트
                            this.parent.SELECT_ITEM[0] = componentsToSelect[0].model;
                        }
                        this.parent.colorupdate();
                        
                        // Vue 강제 업데이트 시도
                        if(this.parent.$forceUpdate) {
                            this.parent.$forceUpdate();
                        }
                    }

                }else{
                    //console.log("empty undo");
                }
                
            }else if(ev.keyCode == 89){  //Ctrl+Y redo
                
                // 이벤트 전파 방지 및 기본 동작 차단
                ev.preventDefault();
                ev.stopPropagation();
                
                // 현재 활성화된 면인지 확인
                if(this.parent && this.parent.CURRENT_FACE !== undefined && this.parent.CURRENT_FACE !== this.face) {
                    console.log(`redo: 비활성 면(${this.face})이라 실행 안함, 현재 활성면: ${this.parent.CURRENT_FACE}`);
                    return;
                }
                
                //에디트 영역은 취소시킨다.
                this.clearSelection();
                this.style.cursor = "default";
                this.mode = "";
                this.parent.selectface(this.face);    //parent에 선택된 배경의 방향을 콜백
                //배경을 인포창에 연결 
                this.parent.selectitem(this.model);
                this.parent.colorupdate(); //컬러값 업데이트                

                if(this.redolist.length > 0){

                    var rlist = this.redolist.pop();
                    const undo_list = [];

                    if(rlist[0].atype == "orderfront" || rlist[0].atype == "orderback"){
                        for(var j = rlist.length-1 ; j >=0 ; j--){
                            const redo = rlist[j];
                            const clone_model = Object.assign({}, redo.component.model); 
                            const clone_obj   = Object.assign({atype:redo.atype, model:clone_model});

                            if(redo.atype == "orderfront"){
                                //맨앞으로
                                const idx = this.component_list.indexOf(redo.component);
                                clone_obj.zidx = idx;
                                if(idx > -1){
                                    this.component_list.splice(idx, 1);        //리스트에서 제거
                                    this.component_list.push(redo.component);  //맨뒤에 다시 추가
                                    this.removeChild(redo.component);
                                    this.appendChild(redo.component);                    
                                }            
                            }else if(redo.atype == "orderback"){
                                //맨뒤로
                                const idx = this.component_list.indexOf(redo.component);
                                clone_obj.zidx = idx;
                                if(idx > -1){
                                    this.component_list.splice(idx, 1);            //리스트에서 제거
                                    this.component_list.unshift(redo.component);   //맨앞에 다시 추가
                                    this.removeChild(redo.component);
                                    this.insertBefore(redo.component, this.firstChild);
                                }
                            }
                            //언두에 넣기
                            clone_obj.component = redo.component;
                            undo_list.push(clone_obj);
    
                            //리두 처리
                            redo.component.model = redo.model;
                            redo.component.model = redo.model;
                            redo.component.updateTransElement();
                        }

                    }else if(rlist[0].atype == "bginfo"){
                        //명찰의 가장 밑 배경
                        rlist.forEach(redo=>{

                            //현재 상태를 언두로 남긴다.
                            const clone_model = Object.assign({}, this.model);
                            const clone_obj   = Object.assign({atype:redo.atype, model:clone_model});
                            undo_list.push(clone_obj);
                                
                            //언두 처리 (배경 다시 그리기)
                            this.model = redo.model;
                            if(this.model.BGTYPE == 0){
                                //컬러 배경
                                this.style.backgroundColor = "#"+this.model.BGCOLOR;
                                this.style.backgroundImage = "";
                                this.style.backgroundRepeat = "no-repeat";
                            }else{
                                //이미지 배경
                                this.style.backgroundSize = "100% 100%";
                                //this.style.backgroundSize = `${this.getPrintWidth(this.model.LAYOUT_WIDTH)}mm  ${this.getPrintHeight(this.model.LAYOUT_HEIGHT)}mm`;
                                //this.style.backgroundSize = this.model.LAYOUT_WIDTH + "px " + this.model.LAYOUT_HEIGHT + "px";
                                this.style.backgroundImage = "url('"+this.model.IMG+"')"
                                this.style.backgroundRepeat = "no-repeat";
                            }
                        });

                    }else{

                        rlist.forEach(redo=>{

                            
                            const clone_model = Object.assign({}, redo.component.model); 
                            const clone_obj   = Object.assign({atype:redo.atype, model:clone_model});
                            
                            //redo는 atype을 다시 처리
                            if(redo.atype == "add"){
                                this.component_list.push(redo.component);
                                this.appendChild(redo.component);
                                                    
                            }else if(redo.atype == "delete"){
                                
                                var idx = this.component_list.indexOf(redo.component);
                                if(idx > -1){
                                    this.component_list.splice(idx, 1);
                                    this.removeChild(redo.component);
                                }
                            }
    
                            //언두에 넣기
                            clone_obj.component = redo.component;
                            undo_list.push(clone_obj);
    
                            //리두 처리 - 모델 데이터 복원
                            redo.component.model = redo.model;
                            
                            // TEMP 값들도 LAYOUT 값과 동기화
                            redo.component.model.TEMP_POSX = redo.component.model.LAYOUT_POSX;
                            redo.component.model.TEMP_POSY = redo.component.model.LAYOUT_POSY;
                            redo.component.model.TEMP_WIDTH = redo.component.model.LAYOUT_WIDTH;
                            redo.component.model.TEMP_HEIGHT = redo.component.model.LAYOUT_HEIGHT;
                            
                            redo.component.updateTransElement();
                            
                            // 강제 DOM 갱신
                            redo.component.style.transform = `translateX(${redo.component.model.LAYOUT_POSX}px) translateY(${redo.component.model.LAYOUT_POSY}px) rotate(${redo.component.model.ROTATE}deg)`;
                            redo.component.style.width = redo.component.model.LAYOUT_WIDTH + "px";
                            redo.component.style.height = redo.component.model.LAYOUT_HEIGHT + "px";
                            
                            // 강제 리플로우 트리거
                            redo.component.offsetHeight;
                            
                        });
                    }
                    if(this.undolist.length > 100){
                        this.undolist.splice(0, 1);
                    }
                    this.undolist.push(undo_list);
                    
                    // 리두 후 관련 컴포넌트들을 선택 상태로 복원
                    const componentsToSelect = [];
                    rlist.forEach(redo => {
                        if(redo.component && this.component_list.includes(redo.component)) {
                            componentsToSelect.push(redo.component);
                        }
                    });
                    
                    if(componentsToSelect.length > 0) {
                        // 먼저 Moveable 타겟을 제거해서 간섭 방지
                        this.moveable.target = null;
                        
                        // DOM 위치가 확실히 적용되도록 더 긴 지연
                        setTimeout(() => {
                            this.selecto.setSelectedTargets(componentsToSelect);
                            this.moveable.target = componentsToSelect;
                            this.cm_targets = componentsToSelect;
                            
                            // Moveable 영역 업데이트
                            this.moveable.updateRect();
                        }, 50);
                        
                        if(componentsToSelect.length === 1) {
                            this.parent.selectitem(componentsToSelect[0].model);
                            // Vue 반응성을 위해 SELECT_ITEM을 직접 업데이트
                            this.parent.SELECT_ITEM[0] = componentsToSelect[0].model;
                        }
                        this.parent.colorupdate();
                        
                        // Vue 강제 업데이트 시도
                        if(this.parent.$forceUpdate) {
                            this.parent.$forceUpdate();
                        }
                    }
                    
                }else{
                    //console.log("empty redo");
                }


            
            }else if(ev.keyCode == 67){ //Ctrl+c copy
                
                DRBackground.copycomponent.splice(0, DRBackground.copycomponent.length);
                const selectedComponents = this.selecto.getSelectedTargets();
                selectedComponents.forEach(cm=>{
                    var clone_model = Object.assign({}, cm.model); //데이터 카피
                    var clone_match = Object.assign({}, cm.MATCHTYPELIST); //데이터 카피
                    DRBackground.copycomponent.push({model:clone_model, match:clone_match});
                });                

            }else if(ev.keyCode == 86){ //Ctrl+V Paste

                //에디트 영역은 취소시킨다.
                this.clearSelection();
                this.style.cursor = "default";
                this.mode = "";
                this.parent.selectface(this.face);    //parent에 선택된 배경의 방향을 콜백
                //배경을 인포창에 연결 
                this.parent.selectitem(this.model);
                this.parent.colorupdate(); //컬러값 업데이트                

                //언두 추가
                var undo_list = [];
                DRBackground.copycomponent.forEach(cm=>{
                    
                    //const copymodel = Object.assign({}, cm); //데이터 카피 (이것도 원본 객체를 쓰면 안됨)
                    //const copymodel = Object.assign({}, cm);
                    const copymodel = JSON.parse(JSON.stringify(cm));
                    
                    // 페이스트시 좌표를 +20, +20 이동 => 엄차장님 요청으로 동일 좌표에 겹치게 처리.
                    //copymodel.model.LAYOUT_POSX += 20;
                    //copymodel.model.LAYOUT_POSY += 20;
                    //copymodel.model.TEMP_POSX += 20;
                    //copymodel.model.TEMP_POSY += 20;
                    
                    const tempcm = new DRComponent(copymodel.model, copymodel.match, false);

                    this.component_list.push(tempcm);
                    this.appendChild(tempcm);
                    tempcm.setMatchTextValue();
                    tempcm.updateTransElement();
                    // Selection will be handled by Selecto after all components are created
                    //console.log("copymodel : " + JSON.stringify(tempcm));    

                    var clone_model = Object.assign({}, copymodel.model); //데이터 카피
                    var clone_obj   = Object.assign({atype:"add", model:clone_model}); //데이터 카피
                    clone_obj.component = tempcm;
                    undo_list.push(clone_obj);
                    
                });     

                if(undo_list.length > 0){
                    if(this.undolist.length > 100){
                        this.undolist.splice(0, 1);
                    }
                    this.undolist.push(undo_list);
                    this.redolist.splice(0, this.redolist.length);
                }
            
                //복제된 컴포넌트를 Selecto로 선택
                const pastedComponents = [];
                DRBackground.copycomponent.forEach((cm, index) => {
                    pastedComponents.push(this.component_list[this.component_list.length - DRBackground.copycomponent.length + index]);
                });
                
                if(pastedComponents.length > 0) {
                    // Selecto와 Moveable 모두에 붙여넣은 컴포넌트들을 선택 설정
                    this.selecto.setSelectedTargets(pastedComponents);
                    this.moveable.target = pastedComponents;
                    this.cm_targets = pastedComponents;
                    
                    if(pastedComponents.length == 1){
                        //복제가 1개면 인포창 연결
                        this.parent.selectitem(pastedComponents[0].model);
                        //컬러값 업데이트
                        this.parent.colorupdate();
                        //위치 백업 - 인포창 갱신 부하 줄이려고
                        pastedComponents[0].setMoveStart(pastedComponents[0]);
                    } else {
                        //다중 선택인 경우 첫번째 컴포넌트 정보를 인포창에 표시
                        this.parent.selectitem(pastedComponents[0].model);
                        this.parent.colorupdate(); //컬러값 업데이트                
                    }
                    
                    // Moveable 영역 업데이트
                    this.moveable.updateRect();
                }

            }
            return false;
        }

        // 선택된 컴포넌트가 있는지 확인
        const selectedComponents = this.selecto.getSelectedTargets();
        
        if(selectedComponents.length > 0){

            if(ev.keyCode == 38){   //up
                ev.preventDefault(); // 스크롤 방지
                
                // 첫 키 입력시에만 언두 저장 (연속 키 입력 방지)
                if(!this.keyboardMoving) {
                    this.saveUndo("move");
                    this.keyboardMoving = true;
                }

                //선택된 컴포넌트가 있다면 이동
                selectedComponents.forEach(cm=>{
                    cm.model.TEMP_POSY = cm.model.TEMP_POSY - 1;
                    cm.model.LAYOUT_POSY = cm.model.LAYOUT_POSY - 1;
                    cm.updateTransElement();
                });
                
                // Moveable 위치 업데이트
                this.moveable.updateRect();
                
                // 인포창 업데이트 (단일 선택인 경우만)
                if(selectedComponents.length === 1) {
                    this.parent.selectitem(selectedComponents[0].model);
                }
                
                return false;   //이걸 해줘야 스크롤이 키이벤트에 의해서 위아래로 안움직임.

            }else if(ev.keyCode == 37){ //left
                ev.preventDefault(); // 기본 동작 방지
                
                // 첫 키 입력시에만 언두 저장 (연속 키 입력 방지)
                if(!this.keyboardMoving) {
                    this.saveUndo("move");
                    this.keyboardMoving = true;
                }

                //선택된 컴포넌트가 있다면 이동
                selectedComponents.forEach(cm=>{
                    cm.model.TEMP_POSX = cm.model.TEMP_POSX - 1;
                    cm.model.LAYOUT_POSX = cm.model.LAYOUT_POSX - 1;
                    cm.updateTransElement();
                });
                
                // Moveable 위치 업데이트
                this.moveable.updateRect();
                
                // 인포창 업데이트 (단일 선택인 경우만)
                if(selectedComponents.length === 1) {
                    this.parent.selectitem(selectedComponents[0].model);
                }
                
                return false;
            }else if(ev.keyCode == 39){ //right
                ev.preventDefault(); // 기본 동작 방지
                
                // 첫 키 입력시에만 언두 저장 (연속 키 입력 방지)
                if(!this.keyboardMoving) {
                    this.saveUndo("move");
                    this.keyboardMoving = true;
                }

                //선택된 컴포넌트가 있다면 이동
                selectedComponents.forEach(cm=>{
                    cm.model.TEMP_POSX = cm.model.TEMP_POSX + 1;
                    cm.model.LAYOUT_POSX = cm.model.LAYOUT_POSX + 1;
                    cm.updateTransElement();
                });
                
                // Moveable 위치 업데이트
                this.moveable.updateRect();
                
                // 인포창 업데이트 (단일 선택인 경우만)
                if(selectedComponents.length === 1) {
                    this.parent.selectitem(selectedComponents[0].model);
                }
                
                return false;
            }else if(ev.keyCode == 40){ //down
                ev.preventDefault(); // 스크롤 방지
                
                // 첫 키 입력시에만 언두 저장 (연속 키 입력 방지)
                if(!this.keyboardMoving) {
                    this.saveUndo("move");
                    this.keyboardMoving = true;
                }

                //선택된 컴포넌트가 있다면 이동
                selectedComponents.forEach(cm=>{
                    cm.model.TEMP_POSY = cm.model.TEMP_POSY + 1;
                    cm.model.LAYOUT_POSY = cm.model.LAYOUT_POSY + 1;
                    cm.updateTransElement();
                });
                
                // Moveable 위치 업데이트
                this.moveable.updateRect();
                
                // 인포창 업데이트 (단일 선택인 경우만)
                if(selectedComponents.length === 1) {
                    this.parent.selectitem(selectedComponents[0].model);
                }
                
                return false;   //이걸 해줘야 스크롤이 키이벤트에 의해서 위아래로 안움직임.
            }

            

        }else{
            //선택된 컴포넌트 없음.
        }
    }

    // 키업 이벤트 핸들러 - 키보드 이동 플래그 리셋
    onkeyup = (ev) => {
        // 화살표 키가 떼어질 때 키보드 이동 플래그 리셋
        if(ev.keyCode == 38 || ev.keyCode == 37 || ev.keyCode == 39 || ev.keyCode == 40) {
            this.keyboardMoving = false;
        }
    }

  
    getPrintWidth(wpx){
        if(wpx == 384){
          return 102;
        }else if(wpx == 264){
          return 70;
        }else if(wpx == 340){
            return 90;
        }else if(wpx == 793){
            return 210;
        }else{
          return 0;
        }
    }

    getPrintHeight(hpx){
        if(hpx == 603){
            return 160;
        }else if(hpx == 567){
            return 150;
        }else if(hpx == 463){
            return 122.5;
        }else if(hpx == 384){
            return 102;
        }else if(hpx == 313){
            return 83;
        }else if(hpx == 263){
            return 70;
        }else if(hpx == 191){
            return 50;

        }else if(hpx == 642){
            return 170;
  
        }else{
            return 0;
        }
    }

}

export default DRBackground;
customElements.define('dr-background', DRBackground);